import { colors } from '@mui/material';

export const partners = [
  {
    name: 'Airbnb',
    logo: 'https://assets.maccarianagency.com/the-front/logos/airbnb.svg',
  },
  {
    name: 'Coinbase',
    logo: 'https://assets.maccarianagency.com/the-front/logos/coinbase.svg',
  },
  {
    name: 'Dribbble',
    logo: 'https://assets.maccarianagency.com/the-front/logos/dribbble.svg',
  },
  {
    name: 'Instagram',
    logo: 'https://assets.maccarianagency.com/the-front/logos/instagram.svg',
  },
  {
    name: 'Netflix',
    logo: 'https://assets.maccarianagency.com/the-front/logos/netflix.svg',
  },
  {
    name: 'Pinterest',
    logo: 'https://assets.maccarianagency.com/the-front/logos/pinterest.svg',
  },
];

export const process = [
  {
    icon: 'fas fa-pencil-alt',
    title: 'Complete your application',
    subtitle:
      'Fill out our standardized application on our platform. Most applicants finish in under an hour',
  },
  {
    icon: 'fas fa-mouse-pointer',
    title: 'Select companies',
    subtitle:
      "We'll immediately match you with any relevant openings and you get to pick which ones you're interested in.",
  },
  {
    icon: 'fas fa-briefcase',
    title: 'Choose your offer',
    subtitle:
      'After 3 days all of your offers will arrive and you will have another 7 days to select your new company.',
  },
];

export const features = [
  'Lifetime Updates & Introduction and Working',
  'Tech support & Mutual Funds',
  'Tons of assets & Lifetime Updates',
  'Integration ready & Tech support',
];

export const jobs = [
  {
    color: colors.blue[500],
    title: 'web design',
    jobTitle: 'Web designer internship',
    type: 'Full time',
    location: 'Milan, Italy',
    date: '3 days ago',
    companyLogo: 'https://assets.maccarianagency.com/the-front/logos/slack.svg',
    companyName: 'Slack',
  },
  {
    color: colors.purple[500],
    title: 'business analytics',
    jobTitle: 'Senior business analysts',
    type: 'Full time',
    location: 'Rome, Italy',
    date: 'Just now',
    companyLogo: 'https://assets.maccarianagency.com/the-front/logos/google-ad-manager.svg',
    companyName: 'Google Ads',
  },
  {
    color: colors.amber[500],
    title: 'photography',
    jobTitle: 'Mid-level photographer',
    type: 'Remote',
    location: 'Yerevan, Armenia',
    date: '1 week ago',
    companyLogo: 'https://assets.maccarianagency.com/the-front/logos/atlassian.svg',
    companyName: 'Atlassian',
  },
  {
    color: colors.indigo[500],
    title: 'video creating',
    jobTitle: 'Senior video creator',
    type: 'Part time',
    location: 'Paris, France',
    date: '2 days ago',
    companyLogo: 'https://assets.maccarianagency.com/the-front/logos/dropbox.svg',
    companyName: 'Dropbox',
  },
  {
    color: colors.pink[500],
    title: 'health & fitness',
    jobTitle: 'Expert fitness consultant',
    type: 'Remote',
    location: 'Yerevan, Armenia',
    date: '1 month ago',
    companyLogo: 'https://assets.maccarianagency.com/the-front/logos/google-ad-manager.svg',
    companyName: 'Google Ads',
  },
  {
    color: colors.green[500],
    title: 'marketing',
    jobTitle: 'Senior digital marketing specialist',
    type: 'Full time',
    location: 'Milan, Italy',
    date: '4 days ago',
    companyLogo: 'https://assets.maccarianagency.com/the-front/logos/google-drive.svg',
    companyName: 'Google Drive',
  },
  {
    color: colors.deepOrange[500],
    title: 'finances & sales',
    jobTitle: 'Senior sales manager',
    type: 'Part Time',
    location: 'Paris, France',
    date: '5 days ago',
    companyLogo: 'https://assets.maccarianagency.com/the-front/logos/mailchimp.svg',
    companyName: 'Mail Chimp',
  },
  {
    color: colors.red[500],
    title: 'graphic design',
    jobTitle: 'Junior graphic designer',
    type: 'Remote',
    location: 'Milan, Italy',
    date: '2 weeks ago',
    companyLogo: 'https://assets.maccarianagency.com/the-front/logos/slack.svg',
    companyName: 'Slack',
  },
  {
    color: colors.purple[500],
    title: 'business analytics',
    jobTitle: 'Senior business analysts',
    type: 'Full time',
    location: 'Rome, Italy',
    date: 'Just now',
    companyLogo: 'https://assets.maccarianagency.com/the-front/logos/google-ad-manager.svg',
    companyName: 'Google Ads',
  },
];

export const advantages = [
  {
    icon: 'fas fa-pencil-alt',
    color: colors.amber,
    title: 'Complete your application',
    subtitle:
      'Fill out our standardized application on our platform. Most applicants finish in under an hour',
  },
  {
    icon: 'fas fa-mouse-pointer',
    color: colors.indigo,
    title: 'Select companies',
    subtitle:
      "We'll immediately match you with any relevant openings and you get to pick which ones you're interested in.",
  },
  {
    icon: 'fas fa-briefcase',
    color: colors.blue,
    title: 'Choose your offer',
    subtitle:
      'After 3 days all of your offers will arrive and you will have another 7 days to select your new company.',
  },
];

export const companies = [
  {
    name: 'Airbnb',
    logo: 'https://assets.maccarianagency.com/the-front/logos/airbnb.svg',
  },
  {
    name: 'Coinbase',
    logo: 'https://assets.maccarianagency.com/the-front/logos/coinbase.svg',
  },
  {
    name: 'Dribbble',
    logo: 'https://assets.maccarianagency.com/the-front/logos/dribbble.svg',
  },
];

export const promo = [
  {
    src: 'https://assets.maccarianagency.com/the-front/photos/coworking/place1.jpg',
    srcSet: 'https://assets.maccarianagency.com/the-front/photos/coworking/place1@2x.jpg 2x',
    alt: '...',
  },
  {
    src: 'https://assets.maccarianagency.com/the-front/photos/coworking/place2.jpg',
    srcSet: 'https://assets.maccarianagency.com/the-front/photos/coworking/place2@2x.jpg 2x',
    alt: '...',
  },
  {
    src: 'https://assets.maccarianagency.com/the-front/photos/coworking/place3.jpg',
    srcSet: 'https://assets.maccarianagency.com/the-front/photos/coworking/place3@2x.jpg 2x',
    alt: '...',
  },
  {
    src: 'https://assets.maccarianagency.com/the-front/photos/coworking/place1.jpg',
    srcSet: 'https://assets.maccarianagency.com/the-front/photos/coworking/place1@2x.jpg 2x',
    alt: '...',
  },
  {
    src: 'https://assets.maccarianagency.com/the-front/photos/coworking/place2.jpg',
    srcSet: 'https://assets.maccarianagency.com/the-front/photos/coworking/place2@2x.jpg 2x',
    alt: '...',
  },
  {
    src: 'https://assets.maccarianagency.com/the-front/photos/coworking/place3.jpg',
    srcSet: 'https://assets.maccarianagency.com/the-front/photos/coworking/place3@2x.jpg 2x',
    alt: '...',
  },
];

export const reviews = [
  {
    authorPhoto: {
      src: 'https://assets.maccarianagency.com/the-front/photos/people/veronica-adams.jpg',
      srcSet: 'https://assets.maccarianagency.com/the-front/photos/people/veronica-adams@2x.jpg 2x',
    },
    authorName: 'Veronica Adams',
    authorOccupation: 'Growth Marketer, Crealytics',
    feedback:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
  },
  {
    authorPhoto: {
      src: 'https://assets.maccarianagency.com/the-front/photos/people/akachi-luccini.jpg',
      srcSet: 'https://assets.maccarianagency.com/the-front/photos/people/akachi-luccini@2x.jpg 2x',
    },
    authorName: 'Akachi Luccini',
    authorOccupation: 'Lead Generation, Alternative Capital',
    feedback:
      'Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
  },
  {
    authorPhoto: {
      src: 'https://assets.maccarianagency.com/the-front/photos/people/jack-smith.jpg',
      srcSet: 'https://assets.maccarianagency.com/the-front/photos/people/jack-smith@2x.jpg 2x',
    },
    authorName: 'Jack Smith',
    authorOccupation: 'Head of Operations, Parkfield Commerce',
    feedback:
      'Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
  },
];
